import React__default from 'react';
import { DeliveryIndicatorComponent, DeliveryIndicatorTooltip } from '@grandvisionhq/shipping';
import { useIntl } from '@grandvisionhq/state';
import { useGetCartEstimatedDeliveryMessage } from '../../hooks/use-get-cart-estimated-delivery-message.js';

const DeliveryIndicatorCartContainer = ({ cartId  })=>{
    const { loadCartEstimationById , deliveryMessage , loading , isFailed  } = useGetCartEstimatedDeliveryMessage();
    const { getLabel  } = useIntl();
    React__default.useEffect(()=>{
        loadCartEstimationById(cartId);
    // We wish to fetch cart estimation only when cartId changes.
    // Adding loadCartEstimationById might cause additional side effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cartId
    ]);
    return /*#__PURE__*/ React__default.createElement(DeliveryIndicatorComponent, {
        deliveryMessage: !isFailed && deliveryMessage.length ? deliveryMessage : getLabel('products.deliveryIndicator.fallbackMessage'),
        loading: loading,
        view: "full",
        tooltipSlot: !isFailed && deliveryMessage.length ? /*#__PURE__*/ React__default.createElement(DeliveryIndicatorTooltip, {
            message: getLabel('products.deliveryIndicator.deliveryTooltip'),
            view: "full"
        }) : null,
        "data-t": "delivery-indicator-cart"
    });
};

export { DeliveryIndicatorCartContainer };
//# sourceMappingURL=DeliveryIndicatorCart.js.map
